import { render, staticRenderFns } from "./Fitstation3DScan.vue?vue&type=template&id=631f310c&scoped=true"
import script from "./Fitstation3DScan.vue?vue&type=script&lang=ts"
export * from "./Fitstation3DScan.vue?vue&type=script&lang=ts"
import style0 from "./Fitstation3DScan.vue?vue&type=style&index=0&id=631f310c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631f310c",
  null
  
)

export default component.exports